const _excluded = ["value", "onChange"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { Button, MenuItem, TextField, Typography } from 'seagull';
import { Controller, useForm } from 'react-hook-form';
import { companyNameValidation, nameValidation, requiredValidation } from 'validators';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { BusinessType } from "../VendorOnboardingModal.utils";
import { StepTemplate } from "../StepTemplate";
import { Step } from "../VendorOnboardingModal.utils";
import { Close12 } from 'seagull/icons';
import { useOnMount } from "../../../hooks/useOnMount";
import { useQboInVob } from "../useQboInVob";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { CheckboxWithLabel } from 'seagull/components/MultiSelectFilterPicker/CheckboxWithLabel';
import styles from "./FirstStep.module.scss";
const numOfInvoicesOptions = [{
  label: 'Less than 10',
  value: '0'
}, {
  label: '10-50',
  value: '10'
}, {
  label: '50-250',
  value: '50'
}, {
  label: '250-1000',
  value: '250'
}, {
  label: 'More than 1000',
  value: '1000'
}];
const businessTypesOptions = [BusinessType.Bookkeeping, BusinessType.Accounting, BusinessType.TaxPreparation, BusinessType.TaxRepresentation, BusinessType.TaxResolution, BusinessType.Marketing, BusinessType.Other];
const businessTypeToLabel = {
  [BusinessType.Bookkeeping]: 'Bookkeeping',
  [BusinessType.Accounting]: 'Accounting',
  [BusinessType.TaxPreparation]: 'Tax Preparation',
  [BusinessType.TaxRepresentation]: 'Tax Representation',
  [BusinessType.TaxResolution]: 'Tax Resolution',
  [BusinessType.Marketing]: 'Marketing',
  [BusinessType.Other]: 'Other'
};
const firstNameValidator = nameValidation(undefined, {
  required: 'Please enter a first name'
});
const lastNameValidator = nameValidation(undefined, {
  required: 'Please enter a last name'
});
const companyNameValidator = companyNameValidation(undefined, {
  required: 'Please enter a company name'
});
const businessTypeValidator = {
  validate: val => val.length > 0 || 'Please select an industry'
};
const numOfInvoicesValidator = requiredValidation('Please enter number of invoices');

const Section = props => /*#__PURE__*/React.createElement("div", {
  className: styles.section
}, /*#__PURE__*/React.createElement(Typography, null, props.title), props.children);

export function FirstStep(props) {
  const {
    initialState,
    onSubmit
  } = props;
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    getFieldState
  } = useForm({
    mode: 'onChange',
    defaultValues: initialState
  });
  const watchBusinessTypes = watch('businessTypes');
  const [showNameSection, setShowNameSection] = useState(true);
  const {
    showQboStep
  } = useQboInVob();
  const {
    VOB_VERTICAL_MULTISELECT
  } = useFeatureFlags();
  useOnMount(() => {
    trigger(['name']).then(() => {
      setShowNameSection(getFieldState('name').invalid);
    });
  });
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React.createElement(StepTemplate, {
    currentStep: Step.First,
    stepper: "Step 1 of ".concat(showQboStep ? '3' : '2'),
    header: "Let\u2019s get you started",
    subHeader: "Tell us about your business so we can customize your account to fit your needs",
    footer: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "vob-step-".concat(Step.First, "-submit"),
      type: "submit",
      className: styles.submitBtn
    }, "Next")
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, showNameSection && /*#__PURE__*/React.createElement("div", {
    className: styles.nameSection
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "name.first",
    rules: firstNameValidator,
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      "data-testid": "vob-first-name",
      placeholder: "First name"
    }))
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "name.last",
    rules: lastNameValidator,
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      "data-testid": "vob-last-name",
      placeholder: "Last name"
    }))
  })), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "companyName",
    rules: companyNameValidator,
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      "data-testid": "vob-company-name",
      placeholder: "Company name"
    }))
  }), /*#__PURE__*/React.createElement(Section, {
    title: VOB_VERTICAL_MULTISELECT ? 'What services do you provide?' : 'What best describes your industry?'
  }, watchBusinessTypes.includes(BusinessType.Other) && watchBusinessTypes.length === 1 ? /*#__PURE__*/React.createElement(Controller, {
    control: control,
    key: "other",
    name: "businessTypeOther",
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      "data-testid": "vob-business-type-other",
      placeholder: "Write your own (optional)",
      autoFocus: true,
      suffix: /*#__PURE__*/React.createElement("span", {
        className: styles.removeOther,
        onClick: () => {
          setValue('businessTypeOther', undefined);
          setValue('businessTypes', []);
        },
        "data-testid": "vob-business-type-other-remove"
      }, /*#__PURE__*/React.createElement(Close12, null))
    }))
  }) : /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "businessTypes",
    rules: businessTypeValidator,
    render: renderProps => {
      const _connectControllerToT = connectControllerToTextField(renderProps),
            {
        value,
        onChange: _onChange
      } = _connectControllerToT,
            rest = _objectWithoutProperties(_connectControllerToT, _excluded);

      const displayValue = value.map(businessType => businessTypeToLabel[businessType]).join(', ');
      return /*#__PURE__*/React.createElement(TextField, _extends({}, rest, {
        select: true,
        "data-testid": "vob-business-type",
        placeholder: "Select",
        value: VOB_VERTICAL_MULTISELECT ? value : value[0] || '',
        onChange: e => {
          VOB_VERTICAL_MULTISELECT || _onChange([e.target.value]);
        },
        SelectProps: {
          multiple: VOB_VERTICAL_MULTISELECT
        },
        displayValue: displayValue
      }), businessTypesOptions.map(optionValue => VOB_VERTICAL_MULTISELECT ? /*#__PURE__*/React.createElement(CheckboxWithLabel, {
        key: optionValue,
        label: businessTypeToLabel[optionValue],
        checked: value.includes(optionValue),
        onChange: e => {
          _onChange(e.target.checked ? value.concat([optionValue]) : value.filter(item => item !== optionValue));
        },
        className: styles.businessTypeOption,
        testId: "bt-option-".concat(optionValue)
      }) : /*#__PURE__*/React.createElement(MenuItem, {
        key: optionValue,
        value: optionValue,
        "data-testid": "bt-option-".concat(optionValue)
      }, businessTypeToLabel[optionValue])));
    }
  })), /*#__PURE__*/React.createElement(Section, {
    title: "How many invoices do you issue a month?"
  }, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "numOfInvoices",
    rules: numOfInvoicesValidator,
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(renderProps), {
      select: true,
      "data-testid": "vob-num-of-invoices",
      placeholder: "Select"
    }), numOfInvoicesOptions.map(_ref => {
      let {
        label,
        value
      } = _ref;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: value,
        value: value,
        "data-testid": "noi-option-".concat(value)
      }, label);
    }))
  })))));
}